module.exports = __webpack_public_path__ + "images/c91c541cefde9f54bedff4e85259385045cdf7044d59537602935b6ac5337782.svg";